import type { DemandBreakdownProduct } from './types/DemandBreakdownProduct';
import type { DemandCalculation } from './types/DemandCalculation';
import type { DemandProductCategory } from './types/DemandProductCategory';

interface HistoricalGroup {
    key: string;
    name: string;
    historicalVolume: number;
    liftingCount: number;
    products: DemandBreakdownProduct[];
}

export const getHistoricalEquivalentGroups = (
    calculation: DemandCalculation,
    category: DemandProductCategory
): HistoricalGroup[] => {
    const groups = new Map<string, HistoricalGroup>();

    for (const vessel of calculation.vessels) {
        for (const vesselCategory of vessel.categories) {
            if (vesselCategory.category !== category) {
                continue;
            }

            for (const group of vesselCategory.equivalenceGroups) {
                const key = `${group.productKey.type}:${group.productKey.value}`;
                const current = groups.get(key) ?? {
                    key,
                    name: group.name,
                    historicalVolume: 0,
                    liftingCount: 0,
                    products: [],
                };
                current.historicalVolume += group.summary.historicalVolume;
                current.liftingCount += group.liftingCount;

                for (const product of group.products) {
                    const existing = current.products.find((candidate) => candidate.productId === product.productId);
                    if (existing) {
                        existing.historicalVolume += product.historicalVolume;
                        existing.liftingCount += product.liftingCount;
                    } else {
                        current.products.push({ ...product });
                    }
                }

                groups.set(key, current);
            }
        }
    }

    return [...groups.values()]
        .map((group) => ({
            ...group,
            products: group.products.sort((first, second) => second.historicalVolume - first.historicalVolume),
        }))
        .sort((first, second) => second.historicalVolume - first.historicalVolume);
};
